module.exports = __webpack_public_path__ + "img/no-people-icon.8cedd99e.png";